import ItemAmountUIModel from '../quoteRefundModels/itemAmount';
import { PenaltyInfoUIModel } from '../penaltyInfo';

export default class RefundsUIModel {
  constructor({
    caseRecordType = {
      ticketType: '',
      tier: '',
    },
    documentNumber = '',
    documentsIssued = [],
    itemResult = {
      reason: '',
      code: '',
      description: '',
      subCode: '',
    },
    newPnr = '',
    onlyTaxesRefunded = false,
    passenger = {
      name: '',
      nameNumber: '',
      email: '',
    },
    penaltyInfo = {},
    refunded = false,
    refundedItemAmount = [],
  }) {
    this.caseRecordType = caseRecordType;
    this.documentNumber = documentNumber;
    this.documentsIssued = documentsIssued;
    this.itemResult = itemResult;
    this.newPnr = newPnr;
    this.onlyTaxesRefunded = onlyTaxesRefunded;
    this.passenger = passenger;
    this.penaltyInfo = new PenaltyInfoUIModel(penaltyInfo);
    this.refunded = refunded;
    this.refundedItemAmount = refundedItemAmount.map(itemAmount => new ItemAmountUIModel(itemAmount));
  }
}